import clsx from 'clsx'
import React from 'react'

type SimpleCardProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
  className?: string
}

export function SimpleCard({
  children,
  className,
  ...divProps
}: SimpleCardProps) {
  return (
    <div
      className={clsx('bg-white border border-subdued rounded-lg', className)}
      {...divProps}
    >
      {children}
    </div>
  )
}
